export default "__VITE_ASSET__5a3ec824__"